import Vue from 'vue'
import teachers from './teachers';

export default {
    namespaced: true,
    state: {
        teacher: {},
        course: {},
        teachers: {},
        courses: {}
    },
    getters: {
        recommendations(state){
            return state;
        }
    },
    mutations: {
        setRecommendations(state, data){
            state.teacher = data.teacher;
            state.course = data.course;
            state.teachers = data.teachers;
            state.courses = data.courses;
        }
    },
    actions: {
        LoadRecommendations ({commit}){
            return new Promise((resolve, reject) => {
                Vue.http.get('recommendations.json')
                    .then(response => response.json())
                    .then(data => {
                        commit('setRecommendations', data);
                        resolve();
                    })
            })
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/recommendations.js